import React from 'react';

import Icons from './Icons';

const StepDiscovery = () => {
  return (
    <div className="container">
      <div className="bg-image">
        <div className="subtitle bigger without">
          Our workflow
          <div className="extra">
            If we work on a project together, you&apos;ll go through this exact
            process:
          </div>
        </div>
        <div className="step first">
          <div className="left-section">
            <div className="number-border">
              <div className="number-step">
                <span>1</span>
              </div>
            </div>
          </div>
          <div className="right-section">
            <h3 className="tt">Discovery workshop</h3>
            <div className="content">
              <div className="row">
                <div className="col-md-6">
                  <p>
                    At this stage we discuss your idea, vision and business
                    targets you want to achieve. It will help us set a scope and
                    requirements.
                  </p>
                </div>
              </div>
            </div>
            <Icons
              yourRoleDetails="Onboard us to the idea and business background"
              outcomeDetails="Defined scope, user stories and estimated budget"
              ourRoleDetails="Facilitate discussion, ask questions"
              durationDetails="2-5 days"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepDiscovery;
